
import Modal from 'react-bootstrap/Modal';

const MyModal = ({children, show, setAddNew, title, isFullscreen=false, size="lg"}) => {
  return (
    <>
      <Modal
        show={show}
        fullscreen={isFullscreen}
        onHide={()=>setAddNew(false)}
        size={size}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
         {title}
        </Modal.Title>
       </Modal.Header>
        <Modal.Body className='pd-50'>
            {children}
        </Modal.Body>
     
      </Modal>
    </>
  );
}

export default MyModal;